import { useEffect, useState } from 'react'
import { Row, Col, FormGroup, Container } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useLocation, useNavigate } from 'react-router-dom'
//
import ButtonX from '../../components/ButtonX'
import ReactstrapInput from '../../components/form/input-fields/ReactstrapInput'
import ReactSelect from '../../components/form/input-fields/ReactSelect'
// import MobileHeader from './MobileHeader'
import Success from './Success'
import { useLanguage } from '../../context/LanguageContext'
import { SUBMIT_INFO } from '../../config'

function PrizeGivingForm({ isSuccess = false }) {
  const navigate = useNavigate()
  const { language } = useLanguage()
  const [loading, setLoading] = useState(false)
  const [isError, setIsError] = useState()
  const { data } = useLocation().state || {}

  const {
    formState: { errors },
    setError,
    reset,
    control,
    handleSubmit,
  } = useForm({
    mode: 'submit',
    defaultValues: {},
    resolver: yupResolver(
      yup.object().shape({
        full_name: yup
          .string()
          .trim()
          .max(250, language.name_250_characters)
          .required(language.required),
        contact_number: yup
          .string()
          .trim()
          .max(11, language.phone_11_characters || 'Invalid phone number')
          .required(language.phone_required),
        delivery_address: yup
          .string()
          .trim()
          .max(500, language.address_500_characters)
          .required(language.required),
        shirt_size: yup.object().required(language.required),
        district: yup.string().trim().required(language.required),
        police_station: yup.string().trim().required(language.required),
      }),
    ),
  })

  useEffect(() => {
    const token = localStorage.getItem('authToken')
    if (token && data) {
      reset({
        ...data,
        shirt_size: { label: data?.shirt_size, value: data?.shirt_size },
      })
    }
  }, [data])

  const onSubmit = async (values) => {
    setLoading(true)
    const token = localStorage.getItem('authToken')

    try {
      const response = await fetch(SUBMIT_INFO, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          ...values,
          contest_winner_id: data?.contest_winner_id,
          shirt_size: values?.shirt_size?.value,
        }),
      })
      const _data = await response.json()
      if (_data?.success) {
        navigate('/prize-success', { replace: true })
      } else {
        if (_data?.error) {
          Object.keys(response?.error).forEach((key) => {
            setError(key, {
              type: 'manual',
              message: _data?.error[key][0],
            })
          })
        } else {
          // showFailedAlert()
        }
      }
    } catch (error) {
      console.log('error', error)
      setIsError(error)
    } finally {
      setLoading(false)
    }
  }

  if (isError) {
    return (
      <h5 className='px-4 vh-100 d-flex align-items-center justify-content-center text-secondary'>
        {language.we_are_working_on_it}
      </h5>
    )
  }
  return (
    <Container
      className='px-4 vh-100 flex-column d-flex overflow-auto'
      style={{ maxWidth: '768px' }}
    >
      {/* <MobileHeader title='Prize Giving Information' /> */}
      {isSuccess && <Success />}
      {!isSuccess && (
        <>
          <Row style={{ marginTop: '8%' }}>
            <ReactstrapInput
              label={language.full_name}
              name={'full_name'}
              type={'text'}
              placeholder={language.write_here}
              errorMessage={errors?.full_name?.message}
              control={control}
              required
            />
            <ReactstrapInput
              label={language.contact_number}
              name={'contact_number'}
              type={'number'}
              placeholder={language.write_here}
              errorMessage={errors?.contact_number?.message}
              control={control}
              required
            />

            <ReactSelect
              label={language.shirt_size}
              name={'shirt_size'}
              placeholder={language.select}
              errorMessage={errors?.shirt_size?.message}
              control={control}
              options={[
                { label: 'S (Chest 36-38)', value: 'S (Chest 36-38)' },
                { label: 'M (Chest 39-41)', value: 'M (Chest 39-41)' },
                { label: 'L (Chest 42-44)', value: 'L (Chest 42-44)' },
                { label: 'XL (Chest 45-47)', value: 'XL (Chest 45-47)' },
                { label: '2XL (Chest 48-50)', value: '2XL (Chest 48-50)' },
              ]}
              required
              isCustom
            />
            <ReactstrapInput
              label={language.district}
              name={'district'}
              placeholder={language.write_here}
              errorMessage={errors?.district?.message}
              control={control}
              required
            />
            <ReactstrapInput
              label={language.thana}
              name={'police_station'}
              placeholder={language.write_here}
              errorMessage={errors?.police_station?.message}
              control={control}
              required
            />
            <ReactstrapInput
              label={language.delivery_address + ` (${language.full_address})`}
              name={'delivery_address'}
              placeholder={language.write_here}
              errorMessage={errors?.delivery_address?.message}
              control={control}
              noGrid
              as={'textarea'}
              required
            />
          </Row>
          <Row className='mt-auto mb-3'>
            <Col>
              <FormGroup>
                <ButtonX
                  isLoading={loading}
                  label={data?.full_name ? language.update : language.submit}
                  onClick={handleSubmit(onSubmit)}
                  className={`w-100 `}
                  style={{ height: 44 }}
                />
              </FormGroup>
            </Col>
          </Row>
        </>
      )}
    </Container>
  )
}

export default PrizeGivingForm
